import React from 'react';
import { Select } from 'antd';
import { toSearchText } from 'utils/text';

const ProductPickerDesktop = ({ viewModel }) => {
  const {
    value,
    onChange,
    mode,
    placeholder,
    selectProps,
    options,
    loading,
  } = viewModel;

  return (
    <Select
      {...selectProps}
      mode={mode}
      value={value}
      onChange={onChange}
      options={options}
      loading={loading}
      placeholder={placeholder}
      optionFilterProp='label'
      filterOption={(input, option) => {
        const inputSearchText = toSearchText(input || '');
        const optionSearchText = option?.searchText || toSearchText(option?.label || '');
        return optionSearchText.includes(inputSearchText);
      }}
      showSearch
    />
  );
};

export default ProductPickerDesktop;